export default __webpack_public_path__ + "static/artifakt-legend-regular-633b20a3360c4f02eaecea58fdd98d93.ttf";